
import { JoinStep } from "./join/types";
import { LoadingState } from "./join/components/LoadingState";
import { InvalidInvitation } from "./join/components/InvalidInvitation";
import { CreatePasswordForm } from "./join/components/CreatePasswordForm";
import { ProfileInfoForm } from "./join/components/ProfileInfoForm";
import { useInvitationData } from "./join/hooks/useInvitationData";
import { usePasswordCreation } from "./join/hooks/usePasswordCreation";
import { useProfileSubmission } from "./join/hooks/useProfileSubmission";

const JoinPage = () => {
  console.log('[JoinPage] Component mounted');
  
  const {
    isLoading,
    invitation,
    company,
    currentStep,
    setCurrentStep,
    invitationId,
    token,
    invalidReason,
    isSuperuserInvitation
  } = useInvitationData();

  const { isLoading: isCreatingPassword, handleCreatePassword } = usePasswordCreation(
    invitationId,
    token,
    invitation?.email || "",
    setCurrentStep
  );

  const { isLoading: isSubmittingProfile, handleProfileSubmit } = useProfileSubmission(
    invitation,
    company
  );

  console.log("[JoinPage] Render state:", {
    currentStep,
    isLoading,
    hasInvitation: !!invitation,
    hasCompany: !!company,
    url: window.location.href
  });

  if (isLoading) {
    console.log('[JoinPage] Showing loading state');
    return <LoadingState />;
  }

  if (!invitation || !company) {
    console.log('[JoinPage] Showing invalid invitation - invitation:', !!invitation, 'company:', !!company);
    return <InvalidInvitation message={invalidReason ?? undefined} />;
  }

  console.log('[JoinPage] Rendering main content for step:', currentStep);

  return (
    <div className="min-h-screen bg-[#375062] flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex items-center justify-center gap-3 mb-2">
          <img src="/icon-mark.png" alt="Doyence" className="h-10 w-10" />
          <h1 className="text-3xl font-bold text-white">
            Doyence
          </h1>
        </div>
        <h2 className="text-center text-xl font-semibold text-white">
          Join {company.name}
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        {currentStep === JoinStep.CREATE_PASSWORD && (
          <>
            {console.log('[JoinPage] Rendering CreatePasswordForm')}
            <CreatePasswordForm
              invitation={invitation}
              company={company}
              isLoading={isCreatingPassword}
              onSubmit={handleCreatePassword}
            />
          </>
        )}
        
        {currentStep === JoinStep.PROFILE_INFO && (
          <>
            {console.log('[JoinPage] Rendering ProfileInfoForm')}
            <ProfileInfoForm
              invitation={invitation}
              company={company}
              isLoading={isSubmittingProfile}
              onSubmit={handleProfileSubmit}
            />
          </>
        )}

        {/* Debug info in development */}
        {process.env.NODE_ENV === 'development' && (
          <div className="mt-4 p-2 bg-gray-100 text-xs rounded">
            <p>Debug: Step = {currentStep}</p>
            <p>Loading = {isLoading.toString()}</p>
            <p>Has invitation = {!!invitation}</p>
            <p>Has company = {!!company}</p>
            <p>URL = {window.location.href}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default JoinPage;
